<template>
    <a-select id="language-select" v-model:value="selectedLanguage" @change="handleLanguageChange" class="lng-dwn">
      <a-select-option v-for="language in languageList" :key="language._id" :value="language.key">
        {{ language.language }}
      </a-select-option>
    </a-select>
</template>

<script setup>
import { ref, watch } from "vue";

const props = defineProps({
  languageList: {
    type: Array,
    required: true
  },
  defaultLang: {
    type: String,
    default: "EN"
  }
});

const emit = defineEmits(["language-changed"]);

const selectedLanguage = ref(props.defaultLang);

watch(() => props.defaultLang, (newLang) => {
  selectedLanguage.value = newLang;
});

const handleLanguageChange = () => {
  emit("language-changed", selectedLanguage.value);
};
</script>

<style scoped>
.lng-dwn {
  width: 180px;
  padding: 2px 5px;
  border-radius: 5px;
}

.language-dropdown {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  margin: 0 20px;
}
</style>